<script>
import Lottie from 'vue-lottie';
import * as animationData from '@assets/animations/lottie/error_animation.json';

export default {
  name: 'ErrorComponent',
  components: {
    Lottie,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default
      },
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  }
}
</script>

<template>
  <div :class="$style.container">
    <lottie
      :options="defaultOptions"
      :height="150"
      :width="150"
      @animCreated="handleAnimation"
    />

    <h3 :class="$style.container__text">{{ text }}</h3>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__text {
    color: $slate-grey;
    margin-top: 2rem;
  }
}

</style>
